import Button from '@hellodarwin/core/lib/components/common/button';
import Input from 'antd/es/input';
import styled from 'styled-components';
export const PanelContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md}px;
  padding: ${({ theme, $bare }) => ($bare ? 0 : theme.spacing.lg)}px;
  padding-bottom: ${({ theme, $bare }) => ($bare ? 0 : theme.spacing.md)}px;
  border: ${({ theme, $bare }) => $bare ? 'none' : `1px solid ${theme.colors.grey_1}`};
  background-color: ${({ theme, $bare }) => $bare ? 'transparent' : theme.colors.white_1};
`;
export const ComposerCard = styled.div `
  border: ${({ theme, $bare }) => $bare ? 'none' : `1px solid ${theme.colors.grey_1}`};
  background-color: ${({ theme, $bare }) => $bare ? 'transparent' : theme.colors.white_1};
  padding: ${({ theme, $bare }) => ($bare ? 0 : theme.spacing.md)}px;
`;
export const MessagesList = styled.div `
  overflow-y: visible;
  overflow-x: visible;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md}px;
  padding-bottom: 4px;
  flex: 1;
  min-height: 0;
`;
export const MessageContainer = styled.div `
  position: relative;
  overflow: visible;
  transition: ${({ theme }) => theme.appearance.transition};
`;
export const MessageBadgeWrapper = styled.div `
  position: absolute;
  top: -8px;
  right: -8px;
  pointer-events: none;
  z-index: 2;
  .ant-badge-count,
  .ant-badge-dot {
    transform: none;
  }
  .ant-badge-dot {
    width: 20px;
    height: 20px;
    border: none;
  }
`;
export const MessageBubble = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}px;
  width: 100%;
  box-sizing: border-box;
  padding: 8px 12px;
  background-color: ${({ theme, $isSelf }) => $isSelf ? theme.colors.green_4 : theme.colors.beige_3};
  border: 1px solid
    ${({ theme, $isSelf }) => $isSelf ? theme.colors.green_3 : theme.colors.beige_2};
  overflow-wrap: anywhere;
  word-break: break-word;
  transition: ${({ theme }) => theme.appearance.transition};
`;
export const MessageActionRow = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.sm}px;
`;
export const MessageActionGroup = styled.div `
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm}px;
`;
export const MessageReplyButton = styled(Button) `
  && {
    padding: ${({ theme }) => `${theme.spacing.xs}px ${theme.spacing.sm}px`};
    min-height: auto;
    color: ${({ theme }) => theme.colors.grey_2};
    background-color: transparent;
    border: none;
  }

  &&:hover,
  &&:focus {
    filter: none;
    color: ${({ theme }) => theme.colors.purple_2};
    background-color: transparent;
    border: none;
  }

  && svg,
  && svg * {
    color: ${({ theme }) => theme.colors.grey_2};
    stroke: currentColor;
  }

  &&:hover svg,
  &&:hover svg *,
  &&:focus svg,
  &&:focus svg * {
    color: ${({ theme }) => theme.colors.purple_2};
    stroke: currentColor;
  }
`;
export const MessageDeleteButton = styled(Button) `
  && {
    padding: ${({ theme }) => `${theme.spacing.xs}px ${theme.spacing.sm}px`};
    min-height: auto;
    color: ${({ theme }) => theme.colors.grey_2};
    background-color: transparent;
    border: none;
  }

  && svg,
  && svg * {
    color: ${({ theme }) => theme.colors.grey_2};
    stroke: currentColor;
  }

  &&:hover,
  &&:focus {
    filter: none;
    color: ${({ theme }) => theme.colors.red_1};
  }

  &&:hover svg,
  &&:hover svg *,
  &&:focus svg,
  &&:focus svg * {
    color: ${({ theme }) => theme.colors.red_1};
    stroke: currentColor;
  }
`;
export const MessageReplyPreview = styled.div `
  position: relative;
  padding: ${({ theme }) => theme.spacing.sm}px;
  padding-right: ${({ theme }) => theme.spacing.lg}px;
  border: 1px solid ${({ theme }) => theme.colors.grey_4};
  background-color: ${({ theme }) => theme.colors.beige_3};
  border-radius: ${({ theme }) => theme.border_radius.sm};
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};

  &:focus {
    outline: ${({ theme, $clickable }) => $clickable ? `2px solid ${theme.colors.purple_2}` : 'none'};
    outline-offset: ${({ theme }) => theme.spacing.xs}px;
  }
`;
export const MessageReplyPreviewContent = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing.xs}px;
  width: 100%;
  min-width: 0;
`;
export const MessageReplyPreviewHeader = styled.div `
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs}px;
  flex: 0 0 auto;
  min-width: 0;
`;
export const ReplyPreviewOverflowIndicator = styled.span `
  display: inline-flex;
  position: absolute;
  right: ${({ theme }) => theme.spacing.sm}px;
  bottom: ${({ theme }) => theme.spacing.sm}px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.grey_2};
  font-size: ${({ theme }) => theme.fonts.body3};
  line-height: ${({ theme }) => theme.fontsLineHeights.body3};
  text-decoration: none;
`;
export const ReplyPreviewExcerptRow = styled.div `
  display: flex;
  align-items: baseline;
  gap: ${({ theme }) => theme.spacing.xs}px;
  width: 100%;
  min-width: 0;
`;
export const MessageReplyPreviewExcerpt = styled.div `
  position: relative;
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  overflow-wrap: anywhere;
  word-break: break-word;
  max-height: ${({ $expanded, theme }) => $expanded ? 'none' : theme.fontsLineHeights.body2};
`;
export const ReplyComposerPreview = styled.div `
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  grid-template-rows: auto auto;
  column-gap: ${({ theme }) => theme.spacing.sm}px;
  row-gap: ${({ theme }) => theme.spacing.xs}px;
  align-items: start;
  padding: ${({ theme }) => theme.spacing.sm}px;
  border: 1px solid ${({ theme }) => theme.colors.grey_4};
  background-color: ${({ theme }) => theme.colors.beige_3};
  border-radius: ${({ theme }) => theme.border_radius.sm};
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
`;
export const ReplyComposerExcerpt = styled.div `
  position: relative;
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  overflow-wrap: anywhere;
  word-break: break-word;
  max-height: ${({ $expanded, theme }) => $expanded ? 'none' : theme.fontsLineHeights.body2};
`;
export const ReplyComposerCancelButton = styled(Button) `
  && {
    justify-self: end;
    padding: 0;
    min-height: auto;
    color: ${({ theme }) => theme.colors.grey_2};
    background-color: transparent;
    border: none;
  }

  && svg {
    color: ${({ theme }) => theme.colors.grey_2};
  }

  &&:hover,
  &&:focus {
    color: ${({ theme }) => theme.colors.grey_1};
    background-color: transparent;
    border: none;
  }

  &&:hover svg,
  &&:focus svg {
    color: ${({ theme }) => theme.colors.grey_1};
  }
`;
export const SuggestionList = styled.div `
  position: absolute;
  z-index: 10;
  top: 100%;
  left: var(--composer-pad-x, 12px);
  right: var(--composer-pad-x, 12px);
  margin-top: 6px;
  border: 1px solid ${({ theme }) => theme.colors.grey_4};
  background: ${({ theme }) => theme.colors.white_1};
  border-radius: ${({ theme }) => theme.border_radius.sm}px;
  max-height: 240px;
  overflow-y: auto;
  overflow-x: hidden;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);
`;
export const SuggestionItem = styled.div `
  padding: 8px 12px;
  cursor: pointer;
  background: ${({ theme, selected }) => selected ? theme.colors.beige_3 : 'transparent'};
`;
export const OverlayText = styled.div `
  position: absolute;
  inset: 0;
  pointer-events: none;
  color: ${({ theme }) => theme.colors.grey_1};
  margin: 0;
  padding: var(--composer-pad-y, 8px) var(--composer-pad-x, 12px);
  font: inherit;
  line-height: inherit;
  letter-spacing: inherit;
  white-space: pre-wrap;
  word-break: break-word;
`;
export const SendButton = styled(Button) `
  && {
    background-color: ${({ theme }) => theme.colors.grey_1};
    color: ${({ theme }) => theme.colors.white_1};
    border: 1px solid ${({ theme }) => theme.colors.grey_1};
    border-radius: ${({ theme }) => theme.border_radius.sm}px;
  }
`;
export const MentionButton = styled(Button) `
  && {
    background-color: ${({ theme }) => theme.colors.white_1};
    color: ${({ theme }) => theme.colors.grey_1};
    border: 1px solid ${({ theme }) => theme.colors.grey_2};
    border-radius: ${({ theme }) => theme.border_radius.sm}px;
  }
  && .mention-icon {
    color: ${({ theme }) => theme.colors.grey_1};
  }
  &&:hover .mention-icon {
    color: ${({ theme }) => theme.colors.white_1};
  }
`;
export const ComposerField = styled.div `
  position: relative;
  overflow: visible;
  --composer-pad-y: 8px;
  --composer-pad-x: 12px;
  font: inherit;
  line-height: inherit;
  letter-spacing: inherit;
`;
export const ComposerFooter = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const LoadMoreWrapper = styled.div `
  display: flex;
  justify-content: center;
`;
export const ComposerTextArea = styled(Input.TextArea) `
  && {
    padding: var(--composer-pad-y, 8px) var(--composer-pad-x, 12px);
    background: transparent;
    font: inherit;
    line-height: inherit;
    letter-spacing: inherit;
  }
`;
